import React, {Component} from 'react';
import {parseInt} from 'lodash';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

class Processor extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  checkInvalidFields() {
    const {
      invoiceSerial, invoiceNumber, invoiceDate, invoicedQuantity, referralGuide, receptionDate, partCode,
      claimedQuantity, claimCode, requestCode, lineNumber,
    } = this.props;
    
    return !invoiceSerial || !invoiceNumber || !partCode || !claimedQuantity || !referralGuide || !receptionDate ||
      !invoiceDate || !invoicedQuantity || !claimCode || !requestCode || !lineNumber;
  }

  handleClick() {
    const {
      invoiceSerial, invoiceNumber, invoiceDate, invoicedQuantity, referralGuide, receptionDate, partCode,
      claimedQuantity, claimCode, requestCode, code, dealerComments, returnOrder, index, lineNumber,
    } = this.props;

    if (this.checkInvalidFields()) {
      this.props.editReturnClaimValue('error', 'Exceptuando los comentarios, todos los campos son requeridos.');
      return;
    }

    if (parseInt(invoicedQuantity, 10) < parseInt(claimedQuantity, 10)) {
      this.props.editReturnClaimValue('error', 'La cantidad solicitada supera la cantidad facturada.');
      return;
    }

    if (!returnOrder) {
      this.props.addNewReturnClaim({
        invoiceSerial, invoiceNumber, invoiceDate, invoicedQuantity, referralGuide, receptionDate, partCode,
        claimedQuantity, claimCode, requestCode, dealerComments, lineNumber,
      }, index);
      this.props.handleClose();
      return;
    }

    this.props.processReturnOrderClaim(returnOrder.code, {
      invoiceSerial, invoiceNumber, invoiceDate, invoicedQuantity, referralGuide, receptionDate, partCode,
      claimedQuantity, claimCode, requestCode, code, dealerComments, lineNumber,
    });
  }

  render() {
    const {processing, loading} = this.props;

    return (
      <Button primary
        content='PROCESAR'
        disabled={loading || processing || this.checkInvalidFields()}
        onClick={this.handleClick}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const {loading, processing, invoiceSerial, invoiceNumber, invoiceDate, invoicedQuantity, referralGuide, receptionDate,
    partCode, claimedQuantity, claimCode, requestCode, dealerComments, code, lineNumber} = state.returnClaim;

  return {
    loading, processing, invoiceSerial, invoiceNumber, invoiceDate, invoicedQuantity, referralGuide, receptionDate,
    partCode, claimedQuantity, claimCode, requestCode, dealerComments, code, lineNumber,
    'returnOrder': state.partsReturnsOrders.selectedOrder,
  };
};

const {
  editReturnClaimValue,
  addNewReturnClaim,
  processReturnOrderClaim,
} = Actions;

export default connect(mapStateToProps, {
  editReturnClaimValue,
  addNewReturnClaim,
  processReturnOrderClaim,
})(Processor);
